import { render, staticRenderFns } from "./FilterConferenceHallsBlock.vue?vue&type=template&id=261d183c&"
import script from "./FilterConferenceHallsBlock.vue?vue&type=script&lang=js&"
export * from "./FilterConferenceHallsBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports